var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-station-container"},[_c('ModalTaskList',{attrs:{"mp3Only":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }